'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;
    this.$stateParams = $stateParams;

    this.manual = {};
  }

  $onInit() {
    this.getUserManual(this.$stateParams.id);
  }

  getUserManual(id) {
    this.$http.get(`/api/UserManuals/${id}`).then(res => {
      this.manual = res.data;
    });
  }

  upload(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/UserManuals/upload',
      file: file,
      data: this.manual,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('usermanual');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/usermanual/edit/edit.controller.js